/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
  'sidebar.smartstock': 'Smart  Stock',
  'sidebar.flujos': 'Flows',
  'flujos.agregarFlujos': 'Create Flows',
  'flujos.modificarFlujos': 'Edit Flows',
  'flujos.eliminarFlujos': 'Delete Flows',
  'flujos.flujoId': 'Flujo Id ',
  'flujos.flujoDescripcion': 'Flow   Description',
  'flujos.flujos': 'Flows',
  'flujos.verFlujos': 'View Flows',
};
